import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { portalMagicRequest, portalMagicExchange } from '../services/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { Mail, Loader2, CheckCircle2, Lock } from 'lucide-react';
import { useEffect } from 'react';

const PortalMagicPage = () => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!email.includes('@')) return toast.error('Email inválido');
    setSending(true);
    try {
      await portalMagicRequest(email);
      setSent(true);
    } catch (err) {
      toast.error('No se pudo enviar el enlace');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 p-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-8" data-testid="portal-magic-page">
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#FF6B4A] to-[#FBBF24] flex items-center justify-center mx-auto mb-3">
            <Lock className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-stone-900">Acceso al portal</h1>
          <p className="text-sm text-stone-500 mt-2">Te enviaremos un enlace seguro a tu email</p>
        </div>
        {sent ? (
          <div className="text-center py-6" data-testid="magic-sent">
            <CheckCircle2 className="w-14 h-14 mx-auto text-emerald-500 mb-3" />
            <p className="font-semibold text-stone-800">¡Revisa tu email!</p>
            <p className="text-sm text-stone-500 mt-1">Si tu email está registrado en algún portal activo, recibirás un enlace en breve. El enlace caduca en 30 minutos.</p>
            <Button variant="outline" className="mt-4" onClick={() => { setSent(false); setEmail(''); }}>Enviar a otro email</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <Input
              type="email" autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
              required
              data-testid="magic-email-input"
            />
            <Button type="submit" disabled={sending} className="w-full bg-stone-900 text-white h-11" data-testid="magic-submit-btn">
              {sending ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Mail className="w-4 h-4 mr-2" />}
              Enviar enlace
            </Button>
          </form>
        )}
        <p className="text-[10px] text-center text-stone-400 mt-6">Powered by Facturcal</p>
      </div>
    </div>
  );
};

export const PortalMagicExchangePage = () => {
  const { magicToken } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await portalMagicExchange(magicToken);
        navigate(`/c/${r.data.access_token}`, { replace: true });
      } catch (e) {
        const code = e.response?.status;
        setError(code === 410 ? 'Este enlace ha caducado' : 'Enlace inválido');
      }
    })();
  }, [magicToken, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50 p-4">
        <div className="bg-white rounded-2xl p-8 max-w-md text-center shadow-lg">
          <Lock className="w-12 h-12 mx-auto text-stone-300 mb-3" />
          <p className="font-semibold text-stone-800">{error}</p>
          <p className="text-sm text-stone-500 mt-1">Solicita un nuevo enlace de acceso.</p>
          <Link to="/portal" className="inline-block mt-4">
            <Button className="bg-[#FF6B4A] text-white">Solicitar nuevo enlace</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <Loader2 className="w-10 h-10 animate-spin text-[#FF6B4A]" />
    </div>
  );
};

export default PortalMagicPage;
